<template>
<div>
  <div :id="`marker-map-${id}`" class="marker-map" style='width: 100%; height: 100%; min-height:300px; min-width:300px;'></div>
</div>
</template>

<script>
// Map preview component
// Renders the marker radius on a map
// Not interactive, but auto-updates based on the position prop value

import L from 'leaflet'
import 'leaflet.markercluster'
// import dates from '../../services/dates'

require('leaflet/dist/leaflet.css')
require('leaflet.markercluster/dist/MarkerCluster.css')
require('leaflet.markercluster/dist/MarkerCluster.Default.css')

delete L.Icon.Default.prototype._getIconUrl

L.Icon.Default.mergeOptions({
  iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
  iconUrl: require('leaflet/dist/images/marker-icon.png'),
  shadowUrl: require('leaflet/dist/images/marker-shadow.png')
})

// import debounce from 'lodash.debounce'

const mapboxUrl = 'https://api.mapbox.com/styles/v1/philippe-look/cisadedxf003i2zo3t5ruhi23/tiles/256/{z}/{x}/{y}?access_token=pk.eyJ1IjoicGhpbGlwcGUtbG9vayIsImEiOiJjaXNhZDl3aHQwMDJjMnVwNWtibDR2azBvIn0.rT49BllHbiANRj9yQL0ozQ'
export default {
  props: [
    'video_coords',
    'image_coords',
    'lat',
    'long'
  ],
  data: function () {
    return {
      id: this._uid,
      doMapMove: true
    }
  },
  mounted: function () {
    this.setupMapPreview(0, 0)
  },
  watch: {
    video_coords: function () {
      this.addMarkers()
    },
    image_coords: function () {
      this.addMarkers()
    }
//    position: function () {
//      this.updateMapPreview()
//    }
  },
  methods: {
    setupMapPreview: function (lat, long) {
      this.mapPreview = {}
      this.mapPreview.leaflet = L.map(`marker-map-${this.id}`)
        .setView([lat, long], 13)
      addMapboxLayerTo(this.mapPreview.leaflet)
      this.setupMarkers()
      this.mapPreview.leaflet.setView([0, 0], 13)
      // this.updateMapPreview()
    },
    updateMapPreview: function () {
      if (!this.markers || !this.markers.getBounds().isValid()) {
        this.mapPreview.leaflet.setView([0, 0], 13)
      } else {
        this.mapPreview.leaflet.on('zoomend', this.mapMoved)
        this.mapPreview.leaflet.fitBounds(
          this.markers.getBounds(), {padding: [50, 50]}
        )
        this.mapPreview.leaflet.on('dragend', this.mapMoved)
      }
    },
    setupMarkers () {
      this.markers = L.markerClusterGroup()
      this.mapPreview.leaflet.addLayer(this.markers)
      this.mapPreview.leaflet.on('click', a => {
        this.doMapMove = true
        if (this.polygon) {
          this.mapPreview.leaflet.removeLayer(this.polygon)
          this.polygon = false
        }
        this.mapMoved()
      })
      this.markers.on('clusterclick', a => {
        this.doMapMove = false

        var recordsV = []
        var recordsI = []
        a.layer.getAllChildMarkers()
          .map(function (l) {
            if (l.properties.type === 'video') {
              recordsV.push(l.properties)
            } else {
              recordsI.push(l.properties)
            }
          })

        if (this.polygon) {
          this.mapPreview.leaflet.removeLayer(this.polygon)
        }

        recordsV = recordsV.sort(this.sort_ids).map(rec => { return rec.id })
        recordsI = recordsI.sort(this.sort_ids).map(rec => { return rec.id })
        this.polygon = L.polygon(a.layer.getConvexHull())
        this.mapPreview.leaflet.addLayer(this.polygon)
        this.$emit('map-moved', recordsV, recordsI)
      })
    },
    addMarkers: function () {
      this.doMapMove = true
      if (this.polygon) {
        this.mapPreview.leaflet.removeLayer(this.polygon)
        this.polygon = false
      }
      if (this.markers) {
        this.markers.clearLayers()
      }
      if (this.video_coords && this.image_coords) {
        this.coords = this.video_coords.map(this.createVideoMarker)
        this.coords = this.coords.concat(this.image_coords.map(this.createImageMarker))
        this.markers.addLayers(this.coords)
        this.markers.on('click', this.clickedMarker)
        this.markers.refreshClusters()

        this.updateMapPreview()
      }
      this.mapMoved()
    },
    clickedMarker (e) {
      var id = e.layer.properties.id
      this.$emit('clicked-marker', id)
    },
    mapMoved (e) {
      if (!this.doMapMove) {
        return
      }
      var bounds = this.mapPreview.leaflet.getBounds()
      var recordsV = []
      var recordsI = []
      this.markers.getLayers()
        .filter(function (l) { return bounds.contains(l.getLatLng()) })
        .map(function (l) {
          if (l.properties.type === 'video') {
            recordsV.push(l.properties)
          } else {
            recordsI.push(l.properties)
          }
        })
      recordsV = recordsV.sort(this.sort_ids).map(rec => { return rec.id })
      recordsI = recordsI.sort(this.sort_ids).map(rec => { return rec.id })
      this.$emit('map-moved', recordsV, recordsI)
    },
    createVideoMarker (record) {
      return this.createMarker(record, 'video')
    },
    createImageMarker (record) {
      return this.createMarker(record, 'image')
    },
    createMarker (record, recordType) {
      var lat = record.point[1]
      var long = record.point[0]
      if (lat && long) {
        var marker = L.marker(L.latLng(lat, long))
        // marker.bindPopup('Video by ' + record.user + ', ' + dates.dateFormat(dates.parseDate(record.created_at)))
        marker.properties = {}
        marker.properties.id = record.id
        marker.properties.type = recordType
        marker.properties.created_at = record.created_at
        marker.properties.relevant = record.relevant
        return marker
      }
    },
    sort_ids (a, b) {
      var dateA = new Date(a.created_at)
      var dateB = new Date(b.created_at)
      if (a.relevant > b.relevant) return -1
      else if (a.relevant < b.relevant) return 1
      if (dateA < dateB) return 1
      if (dateA > dateB) return -1
      return 0
    }
  }
}

function addMapboxLayerTo (mapHandle) {
  L.tileLayer(mapboxUrl).addTo(mapHandle)
}
</script>



// WEBPACK FOOTER //
// MarkerMap.vue?aeb06660